// frontend/src/hooks/useAuth.js
// 認證 Hook

import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

/**
 * 使用認證的 Hook
 * @returns {Object} 認證相關的狀態和函數
 */
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth 必須在 AuthProvider 內使用');
  }

  return context;
};

export default useAuth;
